<template>
  <div o-Container o-Container-App>
    <div class="header-nav">
      <header-nav @clickLeft="goBack" leftArrow title="卡包"></header-nav>
    </div>
    <div
      :style="{
        'padding-bottom': isShowPadding() ? '94px' : '60px',
        'min-height': `calc(100vh - ${isShowPadding() ? '94px' : '60px'})`
      }"
      class="content"
    >
      <div ref="contentTemp" class="content-temp">
        <o-app-list v-bind:source="list.receiveData" v-bind="{ loaded: load }">
          <template v-if="isShowItem" v-slot:render="each">
            <div class="item">
              <div class="item-infor">
                <div class="infor-name">
                  <div class="left">{{ each.data.row.TypeID }}</div>
                  <div class="right">卡号：{{ each.data.row.Number }}</div>
                </div>
                <div class="infor-address">¥{{ each.data.row.Balance }}</div>
                <div
                  v-if="each.data.row.TypeID == '实体卡'"
                  class="infor-binding1"
                >
                  {{ each.data.row.NetworkMode }}
                </div>
                <div class="infor-project">{{ each.data.row.ProjectID }}</div>
              </div>
              <div
                class="remain"
                v-if="
                  each.data.row.AuditStatus != '平台审核中' &&
                    each.data.row.AuditStatus != '财务审核中' &&
                    each.data.row.AuditStatus != '审核通过'
                "
              >
                <div></div>
                <div class="btns">
                  <div v-if="false" @click="cancelCard(each.data.row, 'reCard')">销卡</div>
                  <div @click="goCharging(each.data.row)">去充值</div>
                </div>
                <div v-if="false" @click="pushCard">
                  <span style="padding-right:7px;">去绑定</span
                  ><van-icon name="arrow" size="12px" color="#FF002B" />
                </div>
              </div>
              <div v-else class="review">
                销卡审核中
              </div>
            </div>
          </template>
        </o-app-list>
      </div>
      <empty-list v-if="resideList == 0" title="暂无电卡" />
    </div>
    <div
      :style="{ 'padding-bottom': isShowPadding() ? '34px' : '0' }"
      class="bottom-nav"
    >
      <div @click="pushCard" class="btn-a">添加电卡</div>
    </div>
  </div>
</template>

<script>
import HeaderNav from "@/components/Engine/FrameworkAPPLET/HeaderEngine"; //头部
import EmptyList from "@/components/Engine/FrameworkAPPLET/Empty";
export default {
  name:
    "mms_engine_database_item" /* 这个name暂时不知道用啥用，根据官方文档说的是方便排错的 */,
  components: { HeaderNav, EmptyList },
  data() {
    return {
      payMethod: "", // 支付来源1微信2支付宝
      examineStatus: "", // 审核状态
      cardID: "", //电卡id
      octopus: this.$parent.octopus,
      value: "",
      resideList: -1,
      isShowItem: false,
      TypeIDName: {
        在线卡: 1, // 卡类型
        离线卡: 2,
        虚拟卡: 3
      },
      list: {
        receiveData: {
          data: {
            pageData: { index: 1, listSize: 10, rowSize: 10 }, // 菜单全部加载。
            id: 875, // 接口id
            cellData: [
              { name: "ID" }, //id
              { name: "AlipayBalance" }, // 支付宝余额
              { name: "WechatBalance" }, // 微信余额
              { name: "Number" }, //卡号 1平台审核中 2财务审核中 3审核通过 4审核不通过
              { name: "AuditStatus" }, // 销卡状态 1平台审核中 2财务审核中 3审核通过 4审核不通过
              { name: "Code" }, //code
              { name: "Balance" }, //金额
              { name: "TypeID" }, // 1 是在线卡 2是离线卡
              { name: "CardID" }, //卡 iD
              { name: "NetworkMode" }, //卡类型
              { name: "ProjectID" }, //站点
              { name: "UserID", filterKey: "=", filterValue: "" }, // 用户ID
              { name: "Status", filterKey: "in", filterValue: [3, 5] }
            ]
          }
        }
      }
    };
  },
  activated() {
    // 生命周期
    this.octopus.tools.parseCell(
      this.list.receiveData.data,
      "UserID"
    ).filterValue = this.octopus.passport.id; //用户ID筛选
    document.title = "我的电卡"; //动态设置title
    this.$nextTick(() => {
      this.$refs.contentTemp.style.display = "block";
    });
    this.selectWxOrAli();
  },
  mounted() {
    // 生命周期
    window.addEventListener("resize", this.contentHeight); // 动态改变高度
    this.selectWxOrAli(); //查询环境
  },
  methods: {
    //方法
    async selectWxOrAli() {
      let appletMethods = await this.octopus.applet.appletMethods(); // 获取环境
      if ("getLocation" in appletMethods) {
        this.payMethod = "aliPay"; //支付宝
      } else {
        this.payMethod = "weChat"; // 微信
      }
    },
    // 销卡
    cancelCard(item, status) {
      let that = this;
      if (item.Balance < 0) {
        that.$dialog.alert({
          //提示
          message: "该卡余额不足，无法销卡。",
          showConfirmButton: true,
          showCancelButton: false,
          confirmButtonText: "确定",
          confirmButtonColor: "#FF002B"
        });
        return;
      }
      // 支付宝或者微余额低于1元时不能销卡
      if (
        (item.AlipayBalance <= 1 && item.AlipayBalance != 0) ||
        (item.WechatBalance <= 1 && item.WechatBalance != 0)
      ) {
        that.$dialog.alert({
          //提示
          message: "该卡微信/支付宝有一端平台余额低于1元，无法销卡。",
          showConfirmButton: true,
          showCancelButton: false,
          confirmButtonText: "确定",
          confirmButtonColor: "#FF002B"
        });
        return;
      }
      // 电卡有正在充值订单时
      that.octopus.request.api.post(
        "/Octopus/Engine/List",
        {
          id: 872,
          cellData: [{ name: "CardID", filterKey: "=", filterValue: item.ID }]
        },
        res => {
          if (res.status.code === 200 && res.content.queryData.length > 0) {
            that.$dialog
              .alert({
                //提示
                // title: '提示',
                message: "您有使用该卡的未完成订单，无法销卡。",
                showConfirmButton: true,
                showCancelButton: true,
                confirmButtonText: "取消",
                cancelButtonText: "去完成",
                cancelButtonColor: "#FF002B",
                confirmButtonColor: "#333333"
              })
              .then(() => {})
              .catch(() => {
                that.octopus.router.jump(
                  `/pages/webView/index?webViewUrl=/Applet/Chargingpile/OrderDetail/Page&from=${status}&orderID=${
                    res.content.queryData[0].ID
                  }`
                );
              });
            return;
          } else {
            // 电卡是否有正在充电订单
            that.octopus.request.api.post(
              "/Octopus/Engine/List",
              {
                id: 868,
                cellData: [
                  { name: "CardID", filterKey: "=", filterValue: item.ID },
                  { name: "PaymentWay", filterKey: "=", filterValue: 4 }
                ]
              },
              res => {
                if (res.status.code === 200 && res.content.queryData.length > 0 ) {
                  that.$dialog
                    .alert({
                      //提示
                      // title: '提示',
                      message: "您有使用该卡的未完成订单，无法销卡。",
                      showConfirmButton: true,
                      showCancelButton: true,
                      confirmButtonText: "取消",
                      cancelButtonText: "去完成",
                      cancelButtonColor: "#FF002B",
                      confirmButtonColor: "#333333"
                    })
                    .then(() => {})
                    .catch(() => {
                      that.octopus.router.jump(
                        `/pages/webView/index?webViewUrl=/Applet/Chargingpile/ChargingOrderDetail/Page&orderID=${
                          res.content.queryData[0].ID
                        }`
                      );
                    });
                  return;
                } else {
                  that.cardID = item.ID;
                  that.$dialog
                    .alert({
                      //提示
                      // title: '提示',
                      message:
                        "销卡后将清空该电卡的所有记录\n" +
                        "销卡审核通过后将实际充值余额返还至您的账户，赠送余额将清空。",
                      showConfirmButton: true,
                      showCancelButton: true,
                      confirmButtonText: "取消",
                      cancelButtonText: "销卡",
                      cancelButtonColor: "#FF002B",
                      confirmButtonColor: "#333333"
                    })
                    .then(() => {})
                    .catch(() => {
                      that.cancellation();
                    });
                }
              }
            );
          }
        }
      );
    },
    // 申请销卡接口
    cancellation() {
      let params = {
        applySource: this.payMethod == "aliPay" ? 2 : 1,
        cardID: parseInt(this.cardID)
      };
      this.octopus.request.api.post(
        "/charging_pile/apply/card/cancel",
        params,
        res => {
          if (res.content && res.content.code === 100000) {
            this.octopus.router.jump("/Applet/Chargingpile/applySuccess/Page"); //跳转
          } else if (res.content && res.content.code === 200450) {
            this.$dialog.alert({
              //提示
              message: "该卡存在失败的历史打款记录,请联系平台放",
              showConfirmButton: true,
              showCancelButton: false,
              confirmButtonText: "确定",
              confirmButtonColor: "#FF002B"
            });
          } else {
            this.$dialog.alert({
              //提示
              message: "该卡信息有误请联系管理员",
              showConfirmButton: true,
              showCancelButton: false,
              confirmButtonText: "确定",
              confirmButtonColor: "#FF002B"
            });
          }
        }
      );
    },
    isShowPadding() {
      return this.octopus.applet.isShowAppletPadding(); // 设置高度
    },
    goCharging(item) {
      this.octopus.router.jump(
        "/Applet/Chargingpile/BuyCardDetail/Page?from=reCard&card=" +
          item.ID +
          "&cardStatus=1" +
          "&TypeID=" +
          this.TypeIDName[item.TypeID] +
          "&cardNum=" +
          item.Number
      ); //跳转
    },
    load(res) {
      this.resideList = res.content.queryData.length; // 获取列表数量
      this.isShowItem = true; //列表显示
      if (res.content.queryData.length > 0) {
        //判断列表数量大于0
        this.$refs.contentTemp.style.display = "block"; // 大于0显示
      } else {
        this.$refs.contentTemp.style.display = "none"; //小于0隐藏
      }
    },
    pushCard() {
      this.octopus.router.jump("/Applet/Chargingpile/BindingCard/Page"); //跳转
    },
    goBack() {
      window.history.go(-1); //后退
    },
    //此代码为了兼容小程序和H5头部问题
    contentHeight() {
      let content = document.querySelector(".content"); // 获取content元素
      let bottom = document.querySelector(".bottom-nav"); // 获取底部导航栏
      let contentHeight = window.innerHeight; // 获取window高度
      let bottomHeight = bottom.offsetHeight; // 获取底部高度
      content.style.height = contentHeight - bottomHeight + "px"; // 计算高度
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Applet/Chargingpile/AddCard/Page.vue